import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { logger } from '@/utils/logger/logger';
import { type ButtonAction } from '@heidi/runtime/analytics-vocabulary';

/**
 * The `TrackedButton` emit: `button_clicked` with the action and the button's
 * visible label only (no screen name), Snowplow + Datadog. A failed emit is
 * logged and swallowed so a click never throws.
 */
export function trackUnscopedButtonClicked(action: ButtonAction, label: string): void {
  try {
    track({
      event_name: TrackingEventName.ButtonClicked,
      props: { action, label },
      // button_clicked is Snowplow + Datadog only — keep it off
      // Amplitude, matching the trackButtonClicked chokepoint policy.
      options: { amplitude: false },
    });
  } catch (err) {
    logger.error(err);
  }
}
